import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { resetPasswordAction, clearError } from '@store/actions/user';
import { getError } from '@store/reducers/user/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  errors: getError(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      resetPasswordAction,
      clearError,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
